var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvancedSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.564.564H3.75V3.75H.564z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.875.75C1.255.75.75 1.255.75 1.875v1.5c0 .62.505 1.125 1.125 1.125h12.75c.62 0 1.125-.505 1.125-1.125v-1.5c0-.62-.505-1.125-1.125-1.125H1.875zm12.75 4.5H1.875A1.877 1.877 0 0 1 0 3.375v-1.5C0 .841.84 0 1.875 0h12.75C15.659 0 16.5.842 16.5 1.875v1.5c0 1.034-.84 1.875-1.875 1.875z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.875 9.75A1.877 1.877 0 0 1 0 7.875v-1.5C0 5.341.84 4.5 1.875 4.5h12.75c1.034 0 1.875.841 1.875 1.875V7.5a.375.375 0 0 1-.75 0V6.375c0-.62-.505-1.125-1.125-1.125H1.875c-.62 0-1.125.505-1.125 1.125v1.5C.75 8.495 1.255 9 1.875 9a.375.375 0 0 1 0 .75M3.563 2.438a.188.188 0 0 0-.188.187c0 .206.375.206.375 0a.188.188 0 0 0-.188-.188m0 .75a.563.563 0 1 1 .002-1.126.563.563 0 0 1-.002 1.127M6.188 2.438A.188.188 0 0 0 6 2.624c0 .206.375.206.375 0a.188.188 0 0 0-.188-.188m0 .75a.563.563 0 1 1 .002-1.126.563.563 0 0 1-.002 1.127"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.563 6.938a.188.188 0 0 0-.188.187c0 .206.375.206.375 0a.188.188 0 0 0-.188-.188m0 .75a.563.563 0 1 1 .002-1.126.563.563 0 0 1-.002 1.127M6.188 6.938A.188.188 0 0 0 6 7.125c0 .206.375.206.375 0a.188.188 0 0 0-.188-.188m0 .75a.563.563 0 1 1 .002-1.126.563.563 0 0 1-.002 1.127M6.75 14.25H1.875A1.877 1.877 0 0 1 0 12.375v-1.5C0 9.841.84 9 1.875 9h6a.375.375 0 0 1 0 .75h-6c-.62 0-1.125.505-1.125 1.125v1.5c0 .62.505 1.125 1.125 1.125H6.75a.375.375 0 0 1 0 .75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.563 11.438a.188.188 0 0 0-.188.187c0 .206.375.206.375 0a.188.188 0 0 0-.188-.188m0 .75a.563.563 0 1 1 .002-1.126.563.563 0 0 1-.002 1.127M6.188 11.438a.188.188 0 0 0-.188.187c0 .206.375.206.375 0a.188.188 0 0 0-.188-.188m0 .75a.563.563 0 1 1 .002-1.126.563.563 0 0 1-.002 1.127M12.772 9.75a3.025 3.025 0 0 0-3.022 3.022 3.025 3.025 0 0 0 3.022 3.021 3.025 3.025 0 0 0 3.022-3.021 3.025 3.025 0 0 0-3.022-3.022m0 6.794A3.776 3.776 0 0 1 9 12.772 3.776 3.776 0 0 1 12.772 9a3.776 3.776 0 0 1 3.772 3.772 3.776 3.776 0 0 1-3.772 3.772"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.25 14.25)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.375 3.75a.377.377 0 0 1-.265-.11L.674 1.204a.375.375 0 0 1 .53-.53L3.64 3.109a.376.376 0 0 1-.266.641",
    mask: "url(#b)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedSearch);
export default __webpack_public_path__ + "static/media/advanced-search.4afe41e2f03d0bf5843d21451a14be8c.svg";
export { ForwardRef as ReactComponent };